import { useState, useEffect } from 'react';
import { doc, getDoc, collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

export const useUserCount = () => {
  const [userCount, setUserCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserCount = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // First try to get the 'total' document
        const userCountRef = doc(db, 'user-count', 'total');
        const userCountSnap = await getDoc(userCountRef);
        
        if (userCountSnap.exists()) {
          setUserCount(userCountSnap.data().count || 0);
        } else {
          // If 'total' doesn't exist, get all documents in the collection
          const userCountCollection = collection(db, 'user-count');
          const querySnapshot = await getDocs(userCountCollection);
          
          if (!querySnapshot.empty) {
            // Get the first document (assuming there's only one)
            const firstDoc = querySnapshot.docs[0];
            setUserCount(firstDoc.data().count || 0);
            console.log('Found user count document with ID:', firstDoc.id);
          } else {
            setUserCount(0);
          }
        }
      } catch (err) {
        console.error('Error fetching user count:', err);
        setError(err);
        setUserCount(0);
      } finally {
        setLoading(false);
      }
    };

    fetchUserCount();
  }, []);

  return { userCount, loading, error };
};
